/* eslint-disable react-hooks/rules-of-hooks */
import { UseMutationResult, useMutation } from '@tanstack/react-query';

export const getGeolocation = (
  onSuccess,
): UseMutationResult<unknown, unknown, string> => {
  return useMutation(
    async (ip: string) => {
      const response = await fetch(`/api/geolocation?ip=${ip}`);
      if (!response.ok) {
        throw new Error('Failed to fetch geolocation data');
      }
      return response.json();
    },
    {
      onSuccess,
    }
  );
};
